import { API_URL } from "@/constants/constants";
import axios from "axios";

export default class VentasProvider {
  static async newVenta(venta) {
    const respuesta = await axios.post(API_URL + "/api/venta", venta);
    return respuesta.data.uuid;
  }

  static async getPDF(uuid) {
    window.open(`${API_URL}/api/venta/${uuid}/presupuesto.pdf`, "_blank")
  }

  static async getVentas(venta) {
    const respuesta = await axios.get(API_URL + "/api/ventas", venta);
    return respuesta.data.data.ventas;
  }

  static async deleteVenta(uuid) {
    const respuesta = await axios.delete(`${API_URL}/api/venta/${uuid}`);
    return respuesta.data.message;
  }
}
